import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
//---
import CONFIG from '../../Utils/config';
import { extractErrorMessage, extractErrorMessageRejected } from '../extractError';
//---
const axiosInstant2 = axios.create();
//---
axiosInstant2.interceptors.response.use(function (response) {
    // console.log('tsiNCCslice interceptors.request response::',response);
    return response;
}, function (error) {
    if (error?.response) {
        console.error(`tsiNCCslice interceptors.response.error status:${error.response.status},statusText:${error.response.statusText}:: detail error.response::`, error.response);
    } else {
        console.error('tsiNCCslice interceptors.response.error error.message::', error.message);
    }
    return Promise.reject(error);
});
//-----
const geAuthHeader = () => {
    try {
        const access_token = sessionStorage.getItem('access_token');
        const headers = { 'Authori-zation': `${access_token}`, 'Content-Type': 'application/json' }
        return headers;
    } catch (error) {
        console.error('try catch [geAuthHeader] error.message :', error.message);
    }
}

//-----
export const tsiAuthentication = createAsyncThunk(
    'tsiNCC/Authentication',
    async (data, thunkAPI) => {
        try {
            let Response = await axiosInstant2({ method: "POST", baseURL: CONFIG.API_TSI_ENDPOINT, url: `/auth`, data: data });
            // console.log('tsiAuthentication Response.data >>', Response.data);
            if (Response.status == 200 && Response?.data?.code == 200) {
                if (Response?.data?.data?.access_token) {
                    sessionStorage.setItem('access_token', Response.data.data.access_token)
                }
                return Response.data.data;
            }
            else {
                sessionStorage.removeItem('access_token');
                return thunkAPI.rejectWithValue({ error: Response.data.msg });
            }
        } catch (error) {
            sessionStorage.removeItem('access_token');
            return thunkAPI.rejectWithValue({ error: extractErrorMessage(error) });
        }
    }
);
export const tsiGetMinidoses = createAsyncThunk(
    'tsiNCC/GetMinidoses',
    async (_data, thunkAPI) => {
        try {
            const authHeader = geAuthHeader();
            let Response = await axiosInstant2({ method: "GET", baseURL: CONFIG.API_TSI_ENDPOINT, url: `/microchipList`, headers: authHeader });
            // console.log('tsiGetMinidoses Response.data >>', Response.data);
            if (Response.status == 200 && Response?.data?.code == 200) {
                return Response.data.data;
            }
            else {
                return thunkAPI.rejectWithValue({ error: Response.data.msg });
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: extractErrorMessage(error) });
        }
    }
);
export const tsiGetSupplementFacts = createAsyncThunk(
    'tsiNCC/order/getSupplementFacts',
    async (data, thunkAPI) => {
        try {
            const authHeader = geAuthHeader();
            let Response = await axiosInstant2({ method: "POST", baseURL: CONFIG.API_TSI_ENDPOINT, url: `/getSupplementFacts`, data: data, headers: authHeader });
            // console.log('tsiGetSupplementFacts Response.data >>', Response.data);
            if (Response.status == 200 && Response?.data?.code == 200) {
                return Response.data.data;
            }
            else {
                return thunkAPI.rejectWithValue({ error: Response.data.msg });
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: extractErrorMessage(error) });
        }
    }
);
//---
export const tsiGetProtocolFormulation = createAsyncThunk(
    'tsiNCC/GetProtocolFormulation',
    async (params, thunkAPI) => {
        try {
            const authHeader = geAuthHeader();
            let Response = await axiosInstant2({ method: "GET", baseURL: CONFIG.API_TSI_ENDPOINT, url: `/protocolList`, params: params, headers: authHeader });
            // console.log('tsiGetProtocolFormulation Response.data >>', Response.data);
            if (Response.status == 200 && Response?.data?.code == 200) {
                return Response.data.data;
            }
            else {
                return thunkAPI.rejectWithValue({ error: Response.data.msg });
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: extractErrorMessage(error) });
        }
    }
);
export const tsiOrderAdd = createAsyncThunk(
    'tsiNCC/orderadd',
    async (data, thunkAPI) => {
        try {
            const authHeader = geAuthHeader();
            let Response = await axiosInstant2({ method: "POST", baseURL: CONFIG.API_TSI_ENDPOINT, url: `/add/${data.Order_sn}`, data: data, headers: authHeader });
            // console.log('tsiOrderAdd Response.data >>', Response.data);
            if (Response.status == 200 && Response?.data?.code == 200) {
                return Response.data.data;
            }
            else {
                return thunkAPI.rejectWithValue({ error: Response.data.msg });
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: extractErrorMessage(error) });
        }
    }
);
export const tsiTakeOrder = createAsyncThunk(
    'tsiNCC/takeOrder',
    async (data, thunkAPI) => {
        try {
            const authHeader = geAuthHeader();
            let Response = await axiosInstant2({ method: "POST", baseURL: CONFIG.API_TSI_ENDPOINT, url: `/takeOrder`, data: data, headers: authHeader });
            // console.log('tsiTakeOrder Response.data >>', Response.data);
            if (Response.status == 200 && Response?.data?.code == 200) {
                return Response.data.data;
            }
            else {
                return thunkAPI.rejectWithValue({ error: Response.data.msg });
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: extractErrorMessage(error) });
        }
    }
);
export const tsiUpdateOrder = createAsyncThunk(
    'tsiNCC/updateOrder',
    async (data, thunkAPI) => {
        try {
            const authHeader = geAuthHeader();
            let Response = await axiosInstant2({ method: "POST", baseURL: CONFIG.API_TSI_ENDPOINT, url: `/updateOrder`, data: data, headers: authHeader });
            // console.log('tsiUpdateOrder Response.data >>', Response.data);
            if (Response.status == 200 && Response?.data?.code == 200) {
                return Response.data;
            }
            else {
                return thunkAPI.rejectWithValue({ error: Response.data.msg });
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: extractErrorMessage(error) });
        }
    }
);
export const tsiGetOrderSupplementFacts = createAsyncThunk(
    'tsiNCC/order/getOrderSupplementFacts',
    async (data, thunkAPI) => {
        try {
            const authHeader = geAuthHeader();
            let Response = await axiosInstant2({ method: "POST", baseURL: CONFIG.API_TSI_ENDPOINT, url: `/getOrderSupplementFacts`, data: data, headers: authHeader });
            // console.log('tsiGetOrderSupplementFacts Response.data >>', Response.data);
            if (Response.status == 200 && Response?.data?.code == 200) {
                return Response.data.data;
            }
            else {
                return thunkAPI.rejectWithValue({ error: Response.data.msg });
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: extractErrorMessage(error) });
        }
    }
);
//----
export const tsiNCCSlice = createSlice({
    name: 'tsiNCC',
    initialState: {
        tsiAuthdata: {
            access_token: sessionStorage.getItem('access_token')
        },
        miniDoseListOBJ: {
            count: 0,
            data: [],
        },
        protocolFormulationListOBJ: {
            count: 0,
            data: [],
        },
        orderTakeData: {},
        SupplementFactsData: {},
        orderSupplementFactsData: [],
        //---
        isOrderAddedTSI: false,
        //---
        isFetchingOBJ: {},
        isError: false,
        errorMessage: '',

    },
    reducers: {
        updateState: (state, { payload }) => {
            if (payload.isError !== undefined) { state.isError = payload.isError }
            if (payload.errorMessage !== undefined) { state.errorMessage = payload.errorMessage }
            if (payload.SupplementFactsData !== undefined) { state.SupplementFactsData = {} }
            //---
            if (payload.isOrderAddedTSI !== undefined) { state.isOrderAddedTSI = payload.isOrderAddedTSI }
            return state;
        },
    },
    extraReducers: (builder) => {
        //-----
        builder.addCase(tsiAuthentication.fulfilled, (state, { payload }) => {
            try {
                state.tsiAuthdata = payload || {};
                state.isFetchingOBJ.tsiAuthentication = false;
                state.isError = false;
                state.errorMessage = '';
                return state;
            } catch (error) {
                console.error('[tsiAuthentication.fulfilled] try catch error >>', error);
            }
        })
        builder.addCase(tsiAuthentication.rejected, (state, { payload }) => {
            try {
                state.tsiAuthdata = {};
                state.isFetchingOBJ.tsiAuthentication = false;
                state.isError = true;
                state.errorMessage = extractErrorMessageRejected(payload);
            } catch (error) {
                console.error('[tsiAuthentication.rejected] try catch error >>', error);
            }
        })
        builder.addCase(tsiAuthentication.pending, (state) => {
            state.isFetchingOBJ.tsiAuthentication = true;
        })
        //----
        builder.addCase(tsiGetMinidoses.fulfilled, (state, { payload }) => {
            try {
                state.miniDoseListOBJ = payload || {};
                state.isFetchingOBJ.tsiGetMinidoses = false;
                state.isError = false;
                state.errorMessage = '';
                return state;
            } catch (error) {
                console.error('[tsiGetMinidoses.fulfilled] try catch error >>', error);
            }
        })
        builder.addCase(tsiGetMinidoses.rejected, (state, { payload }) => {
            try {
                state.isFetchingOBJ.tsiGetMinidoses = false;
                state.isError = true;
                state.errorMessage = extractErrorMessageRejected(payload);
            } catch (error) {
                console.error('[tsiGetMinidoses.rejected] try catch error >>', error);
            }
        })
        builder.addCase(tsiGetMinidoses.pending, (state) => {
            state.isFetchingOBJ.tsiGetMinidoses = true;
        })
        //----
        builder.addCase(tsiGetSupplementFacts.fulfilled, (state, { payload }) => {
            try {
                state.SupplementFactsData = payload || {};
                state.isFetchingOBJ.tsiGetSupplementFacts = false;
                state.isError = false;
                state.errorMessage = '';
                return state;
            } catch (error) {
                console.error('[tsiGetSupplementFacts.fulfilled] try catch error >>', error);
            }
        })
        builder.addCase(tsiGetSupplementFacts.rejected, (state, { payload }) => {
            try {
                state.isFetchingOBJ.tsiGetSupplementFacts = false;
                state.isError = true;
                state.errorMessage = extractErrorMessageRejected(payload);
            } catch (error) {
                console.error('[tsiGetSupplementFacts.rejected] try catch error >>', error);
            }
        })
        builder.addCase(tsiGetSupplementFacts.pending, (state) => {
            state.isFetchingOBJ.tsiGetSupplementFacts = true;
        })
        //----
        builder.addCase(tsiGetProtocolFormulation.fulfilled, (state, { payload }) => {
            try {
                state.protocolFormulationListOBJ = payload || [];
                state.isFetchingOBJ.tsiGetProtocolFormulation = false;
                state.isError = false;
                state.errorMessage = '';
                return state;
            } catch (error) {
                console.error('[tsiGetProtocolFormulation.fulfilled] try catch error >>', error);
            }
        })
        builder.addCase(tsiGetProtocolFormulation.rejected, (state, { payload }) => {
            try {
                state.isFetchingOBJ.tsiGetProtocolFormulation = false;
                state.isError = true;
                state.errorMessage = extractErrorMessageRejected(payload);
            } catch (error) {
                console.error('[tsiGetProtocolFormulation.rejected] try catch error >>', error);
            }
        })
        builder.addCase(tsiGetProtocolFormulation.pending, (state) => {
            state.isFetchingOBJ.tsiGetProtocolFormulation = true;
        })
        //----
        builder.addCase(tsiOrderAdd.fulfilled, (state, { payload }) => {
            try {
                state.isOrderAddedTSI = true;
                state.isFetchingOBJ.tsiOrderAdd = false;
                state.isError = false;
                state.errorMessage = '';
                return state;
            } catch (error) {
                console.error('[tsiOrderAdd.fulfilled] try catch error >>', error);
            }
        })
        builder.addCase(tsiOrderAdd.rejected, (state, { payload }) => {
            try {
                state.isOrderAddedTSI = false;
                state.isFetchingOBJ.tsiOrderAdd = false;
                state.isError = true;
                state.errorMessage = extractErrorMessageRejected(payload);
            } catch (error) {
                console.error('[tsiOrderAdd.rejected] try catch error >>', error);
            }
        })
        builder.addCase(tsiOrderAdd.pending, (state) => {
            state.isFetchingOBJ.tsiOrderAdd = true;
        })
        //----
        builder.addCase(tsiTakeOrder.fulfilled, (state, { payload }) => {
            try {
                state.orderTakeData = payload || {};
                state.isFetchingOBJ.tsiTakeOrder = false;
                state.isError = false;
                state.errorMessage = '';
                return state;
            } catch (error) {
                console.error('[tsiTakeOrder.fulfilled] try catch error >>', error);
            }
        })
        builder.addCase(tsiTakeOrder.rejected, (state, { payload }) => {
            try {
                state.isFetchingOBJ.tsiTakeOrder = false;
                state.isError = true;
                state.errorMessage = extractErrorMessageRejected(payload);
            } catch (error) {
                console.error('[tsiTakeOrder.rejected] try catch error >>', error);
            }
        })
        builder.addCase(tsiTakeOrder.pending, (state) => {
            state.isFetchingOBJ.tsiTakeOrder = true;
        })
        //----
        builder.addCase(tsiUpdateOrder.fulfilled, (state, { payload }) => {
            try {
                state.isFetchingOBJ.tsiUpdateOrder = false;
                state.isError = false;
                state.errorMessage = '';
                return state;
            } catch (error) {
                console.error('[tsiUpdateOrder.fulfilled] try catch error >>', error);
            }
        })
        builder.addCase(tsiUpdateOrder.rejected, (state, { payload }) => {
            try {
                state.isFetchingOBJ.tsiUpdateOrder = false;
                state.isError = true;
                state.errorMessage = extractErrorMessageRejected(payload);
            } catch (error) {
                console.error('[tsiUpdateOrder.rejected] try catch error >>', error);
            }
        })
        builder.addCase(tsiUpdateOrder.pending, (state) => {
            state.isFetchingOBJ.tsiUpdateOrder = true;
        })
        //----
        builder.addCase(tsiGetOrderSupplementFacts.fulfilled, (state, { payload }) => {
            try {
                state.orderSupplementFactsData = payload || [];
                state.isFetchingOBJ.tsiGetOrderSupplementFacts = false;
                state.isError = false;
                state.errorMessage = '';
                return state;
            } catch (error) {
                console.error('[tsiGetOrderSupplementFacts.fulfilled] try catch error >>', error);
            }
        })
        builder.addCase(tsiGetOrderSupplementFacts.rejected, (state, { payload }) => {
            try {
                state.isFetchingOBJ.tsiGetOrderSupplementFacts = false;
                state.isError = true;
                state.errorMessage = extractErrorMessageRejected(payload);
            } catch (error) {
                console.error('[tsiGetOrderSupplementFacts.rejected] try catch error >>', error);
            }
        })
        builder.addCase(tsiGetOrderSupplementFacts.pending, (state) => {
            state.isFetchingOBJ.tsiGetOrderSupplementFacts = true;
        })
        //---
    }
});
//---
export const { updateState } = tsiNCCSlice.actions;
export const tsiNCCSelector = (state) => state.ncc.tsiNCC;
